import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'

async function establishmentDepartmentChange() {
  const formStore = useFormStore()
  const { immigrationDepartmentId = '', establishmentNumber = '' } = formStore.form.values
  if (!immigrationDepartmentId || !establishmentNumber) return
  let res = await apiHelperService.post('/api/establishment/information/basicInfo', {
    departmentId: immigrationDepartmentId,
    estabNumber: establishmentNumber
  })
  if (!res) return
}
export default function (actionName, actionParams) {
  switch (actionName) {
    case 'establishmentDepartmentChange':
      establishmentDepartmentChange()
      break
    default:
      break
  }
}
